import { Link } from 'react-router-dom';

const footerLinks = {
  快速导航: [
    { label: '首页', path: '/' },
    { label: '软件分类', path: '/category/system-tools' },
    { label: '使用教程', path: '/article/getting-started' },
    { label: '关于我们', path: '/about' },
  ],
  热门分类: [
    { label: '系统工具', path: '/category/system-tools' },
    { label: '办公软件', path: '/category/office-software' },
    { label: '多媒体工具', path: '/category/multimedia' },
    { label: '安全防护', path: '/category/security' },
  ],
  帮助支持: [
    { label: '安装教程', path: '/article/install-guide' },
    { label: '常见问题', path: '/article/faq' },
    { label: '功能介绍', path: '/article/features-intro' },
    { label: '联系客服', path: '/about#contact' },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-background-100">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
            <div>
              <Link to="/" className="inline-block mb-4">
                <span className="text-2xl font-heading font-bold text-primary-500">
                  91<span className="text-foreground-800">免费版</span>
                </span>
              </Link>
              <p className="text-sm text-foreground-600 leading-relaxed">
                91免费版是值得信赖的免费软件下载平台，致力于为用户提供安全、纯净、高效的软件资源。无需付费，即可畅享全部核心功能。
              </p>
            </div>

            {Object.entries(footerLinks).map(([title, links]) => (
              <div key={title}>
                <h4 className="text-sm font-semibold text-foreground-900 mb-4">
                  {title}
                </h4>
                <ul className="flex flex-col gap-2.5">
                  {links.map((link) => (
                    <li key={link.path}>
                      <Link
                        to={link.path}
                        className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap"
                      >
                        {link.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          <div className="mt-12 pt-8 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-500">
              &copy; {new Date().getFullYear()} 91免费版 版权所有 | 本站所有资源均来自互联网，仅供学习交流使用
            </p>
            <div className="flex items-center gap-5">
              <a href="#" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap" rel="nofollow">
                隐私政策
              </a>
              <a href="#" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap" rel="nofollow">
                使用条款
              </a>
              <a href="#" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap" rel="nofollow">
                免责声明
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}